import { TReduxActions } from '../../types/redux';
import { globalErrorActionTypes } from '../../constants/actionTypes';

export function globalErrorReducer(state: string | null = null, action: TReduxActions) {
  switch (action.type) {
    case globalErrorActionTypes.SET_ERROR:
      return action.payload;

    default:
      return state;
  }
}
